
// generic map for icon type -> icon class (ii5)

import {PROJECT_LIST_CONFIG} from "../../../views/list/@config"
import {PROJECT_BOARD_CONFIG} from "../../../views/board/@config"
import {PROJECT_TABLE_CONFIG} from "../../../views/table/@config"
import {PROJECT_GANTT_CONFIG} from "../../../views/gantt/@config"
import {PROJECT_CALENDAR_CONFIG} from "../../../views/calendar/@config"
import {CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG} from "../../../views/events-summary/@config"
import {CUSTOM_VIEW_EXPENSES_CONFIG} from "../../../views/expenses/@config-custom"
import {PROJECT_WORKLOAD_CONFIG} from "../../../views/workload/@config"
import {PROJECT_ACTIVITY_CONFIG} from "../../../views/activity/@config"
import {CUSTOM_VIEW_WHATS_DONE_CONFIG} from "../../../views/whats-done/@config"
import {CUSTOM_VIEW_PASTDUE_CONFIG} from "../../../views/pastdue/@config"
import {CUSTOM_VIEW_PRIORITIES_CONFIG} from "../../../views/priorities/@config"
import {CUSTOM_VIEW_ACTION_REQUIRED_CONFIG} from "../../../views/action-required/@config"
import {CUSTOM_VIEW_TASKS_BY_USER_CONFIG} from "../../../views/tasks-by-user/@config"
import {CUSTOM_VIEW_DASHBOARD_CONFIG} from "../../../views/dashboard/@config"
import {PROJECTS_PORTFOLIO_CONFIG} from "../../../views/portfolio/@config"
import {PROJECTS_PROJECTS_LIST_CONFIG} from "../../../views/projects-list/@config"

// this is Item icons - i.e. tasks
// see ProjectIconDictionary for project Icons
// gd.const.ii
export const ItemIcon : any = {

    // Theses 3 a re the options
    // projectIcons    : ProjectIconOptions,
    // taskIcons       : TaskIconOptions,
    // docIcons        : DocIconOptions,
    // END

    // a chto eto vnizu ?

    workspace   : 'i5-departments',

    tasks: "i5-tasks",

    task: 'ii5-task',
    idea: 'ii5-idea',
    question: 'ii5-question',
    bug: 'ii5-bug',

    beer: 'ii5-beer',
    book: 'ii5-book',
    briefcase: 'ii5-briefcase',
    social_broadcast: 'ii5-broadcast',

    upload: 'ii5-cloud-upload',
    download: 'ii5-cloud-download',


    device_mobile: "ii5-device-mobile",
    device_desktop: "ii5-device-desktop",

    phone: "ii5-phone",
    money: "ii5-money",

    device_video: "ii5-device-camera-video",
    device_camera: "ii5-device-camera",
    database: "ii5-database",
    file_binary: "ii5-file-binary",
    file_code: "ii5-file-code",
    file_contact: "ii5-file-contact",
    file_text: "ii5-file-text",
    flame: "ii5-flame",
    globe: "ii5-globe",
    gift: "ii5-gift",
    dev_gist: "ii5-project-dev",
    graph: "ii5-graph",
    law: "ii5-law",
    key: "ii5-key",
    // link: "ii5-link",
    location: "ii5-location",
    mail: "ii5-mail-black",
    mail_read: "ii5-mail-read",
    mention: "ii5-mention",
    milestone: "ii5-milestone",
    study: "ii5-graduation",
    pulse: "ii5-pulse",
    social_rss: "ii5-rss",
    search: "ii5-search",
    squirrel: "ii5-squirrel",
    steps: "ii5-steps",
    telescope: "ii5-telescope",
    tools: "ii5-tools",
    contact: "ii5-contact",
    anchor: "ii5-anchor",
    bookmark: "ii5-bookmark",
    burst: "ii5-burst",
    first_aid: "ii5-first-aid",
    paint_bucket: "ii5-paint-bucket",
    quote: "ii5-quote",
    social_youtube: "ii5-social-youtube",
    trophy: "ii5-trophy",
    shield: "ii5-shield",
    shopping_cart: "ii5-shopping-cart",
    rocket: "ii5-rocket",
    brush: "ii5-brush",
    bucket: "ii5-bucket",
    social_twitter: "ii5-social-twitter",
    userSearch: "ii5-user-search",
    megaphone: "ii5-megaphone",
    tshirt: "ii5-tshirt",
    wheelchair:"ii5-wheelchair",


    // NEW
    server: "ii5-server",
    microchip: "ii5-microchip",
    lightning: "ii5-lightning",
    network: "ii5-chart-network",
    resources: "ii5-resource-planning",
    file_audio: "ii5-file-audio",
    file_media: "ii5-file-media",
    file_video: "ii5-file-video",
    file_archive: "ii5-file-archive",
    spreadsheet: "ii5-file-spreadsheet",
    credit_card: "ii5-credit-card",
    suitcase: "ii5-suitcase-rolling",
    graduate: "ii5-mortar-board",
    pencil: "ii5-pencil-alt",
    paint_roller: "ii5-paint-roller",
    chess: "ii5-game-board",
    game_console: "ii5-game-console-handheld",
    music: "ii5-music",
    speaker: "ii5-speaker",
    microphone: "ii5-microphone",
    football_ball: "ii5-football-ball",
    flask: "ii5-flask-potion",
    birthday_cake: "ii5-birthday-cake",
    hotel: "ii5-hotel",
    flag: "ii5-bottleneck",
    geo: "ii5-geo",
    watch: "ii5-watch",
    feather: "ii5-feather-alt",
    magic_wand: "ii5-actions",
    smile: "ii5-smile",
    smile_sad: "ii5-smile-sad",
    zzz: "ii5-zzz",
    life_ring:"ii5-life-ring",
    tachometer: "ii5-tachometer-alt-average",



    // folder: "ii5-open-folder", open_folder: "ii5-open-folder",
    folder: "ii5-folder", open_folder: "ii5-folder",
    project: "ii5-project",
    page: 'ii5-task-list',
    // group: 'i5-group',
    dev: "ii5-project-dev",
    sprint: "ii5-sprint",
    backlog: "ii5-someday-3", someday_3: "ii5-someday-3",
    tag: "ii5-tag",
    kanban: "ii5-kanban",
    scrum: "ii5-agile",
    files: "ii5-documents",
    report: "i5-chart-bar",

    mobile: "ii5-device-mobile",
    desktop: "ii5-device-desktop",


    support: "ii5-support",
    requests: "ii5-archive", archive: "ii5-archive",


    api: "ii5-api",
    qa: "ii5-qa",



    paint: "ii5-paint-bucket",

    leads: "ii5-leads",



    calendar: "ii5-calendar",
    cloud: "ii5-cloud",
    home: "ii5-home",
    mail_black: "ii5-mail-black",
    projection_screen: "ii5-projection-screen",

    android         : "ii5-social-android",
    social_android  : "ii5-social-android",
    apple           : "ii5-social-apple",
    social_apple    : "ii5-social-apple",
    windows         : "ii5-social-windows",
    social_windows  : "ii5-social-windows",

    education       : "ii5-graduation",
    graduation_cap  : "ii5-graduation",
    assets          : "ii5-assets",

    event           : "ii5-event",

    img             : "ii5-image",
    inventory       : "ii5-inventory",

    target          : 'ii5-target',
    taskList        : 'ii5-task-list',
    aim             : 'ii5-aim',
    request         : 'ii5-request',
    request2        : 'ii5-request2',

    twitter         : 'ii5-social-twitter',






    wiki:           'ii5-wiki',
    information:    'ii5-information',

    brand:          'ii5-brand',

    graduation:     'ii5-graduation',
    image:          'ii5-image',


    group           : 'i5-group',

    link            : 'i5-copy-link',
    embed           : 'i5-embeded-code',
    facebook        : 'i5-facebook',
    figma           : 'i5-figma',
    googleCalendar  : 'i5-google-cal',
    googleDoc       : 'i5-google-doc',
    googleMap       : 'i5-google-maps',
    googleSheet     : 'i5-google-sheet',
    googleSlides    : 'i5-google-slides',
    twitterX        : 'i5-twitter',
    youtube         : 'i5-youtube',

    'view'                  : 'i5-view',
    'view-list'             : PROJECT_LIST_CONFIG.icon,
    'view-table'            : PROJECT_TABLE_CONFIG.icon,
    'view-board'            : PROJECT_BOARD_CONFIG.icon,
    'view-calendar'         : PROJECT_CALENDAR_CONFIG.icon,
    'view-events-summary'   : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.icon,
    'view-expenses'         : CUSTOM_VIEW_EXPENSES_CONFIG.icon,
    'view-gantt'            : PROJECT_GANTT_CONFIG.icon,
    'view-workload'         : PROJECT_WORKLOAD_CONFIG.icon,
    'view-activity'         : PROJECT_ACTIVITY_CONFIG.icon,
    'view-what-is-done'     : CUSTOM_VIEW_WHATS_DONE_CONFIG.icon,
    'view-pastdue'          : CUSTOM_VIEW_PASTDUE_CONFIG.icon,
    'view-priorities'       : CUSTOM_VIEW_PRIORITIES_CONFIG.icon,
    'view-action-required'  : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.icon,
    'view-tasks-by-user'    : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.icon,
    'view-portfolio'        : PROJECTS_PORTFOLIO_CONFIG.icon,
    'view-projects-list'    : PROJECTS_PROJECTS_LIST_CONFIG.icon,
    'view-dashboard'        : CUSTOM_VIEW_DASHBOARD_CONFIG.icon,

};

// export default ConstItemIcon;
